import Kt, { isAxiosError as Br } from "axios";
import { useMemo as Vr } from "react";
var ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ne(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var $ = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, Gr = $, G = !Gr(function() {
  var t = (function() {
  }).bind();
  return typeof t != "function" || t.hasOwnProperty("prototype");
}), qt = G, Ht = Function.prototype, Ce = Ht.call, Kr = qt && Ht.bind.bind(Ce, Ce), m = qt ? Kr : function(t) {
  return function() {
    return Ce.apply(t, arguments);
  };
}, qr = m, K = qr({}.isPrototypeOf), Y = function(t) {
  return t && t.Math === Math && t;
}, T = (
  // eslint-disable-next-line es/no-global-this -- safe
  Y(typeof globalThis == "object" && globalThis) || Y(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Y(typeof self == "object" && self) || Y(typeof ce == "object" && ce) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ (function() {
    return this;
  })() || ce || Function("return this")()
), Hr = G, Wt = Function.prototype, Qe = Wt.apply, et = Wt.call, Wr = typeof Reflect == "object" && Reflect.apply || (Hr ? et.bind(Qe) : function() {
  return et.apply(Qe, arguments);
}), zt = m, zr = zt({}.toString), Yr = zt("".slice), ae = function(t) {
  return Yr(zr(t), 8, -1);
}, Jr = ae, Xr = m, Be = function(t) {
  if (Jr(t) === "Function") return Xr(t);
}, Ne = typeof document == "object" && document.all, Zr = typeof Ne > "u" && Ne !== void 0, Yt = {
  all: Ne,
  IS_HTMLDDA: Zr
}, Jt = Yt, Qr = Jt.all, _ = Jt.IS_HTMLDDA ? function(t) {
  return typeof t == "function" || t === Qr;
} : function(t) {
  return typeof t == "function";
}, Xt = {}, en = $, q = !en(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), tn = G, J = Function.prototype.call, Ve = tn ? J.bind(J) : function() {
  return J.apply(J, arguments);
}, Zt = {}, Qt = {}.propertyIsEnumerable, er = Object.getOwnPropertyDescriptor, rn = er && !Qt.call({ 1: 2 }, 1);
Zt.f = rn ? function(e) {
  var r = er(this, e);
  return !!r && r.enumerable;
} : Qt;
var tr = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, nn = m, an = $, on = ae, ue = Object, sn = nn("".split), rr = an(function() {
  return !ue("z").propertyIsEnumerable(0);
}) ? function(t) {
  return on(t) === "String" ? sn(t, "") : ue(t);
} : ue, nr = function(t) {
  return t == null;
}, cn = nr, un = TypeError, oe = function(t) {
  if (cn(t)) throw un("Can't call method on " + t);
  return t;
}, ln = rr, fn = oe, ar = function(t) {
  return ln(fn(t));
}, tt = _, or = Yt, dn = or.all, j = or.IS_HTMLDDA ? function(t) {
  return typeof t == "object" ? t !== null : tt(t) || t === dn;
} : function(t) {
  return typeof t == "object" ? t !== null : tt(t);
}, Ge = {}, le = Ge, fe = T, pn = _, rt = function(t) {
  return pn(t) ? t : void 0;
}, ir = function(t, e) {
  return arguments.length < 2 ? rt(le[t]) || rt(fe[t]) : le[t] && le[t][e] || fe[t] && fe[t][e];
}, vn = typeof navigator < "u" && String(navigator.userAgent) || "", sr = T, de = vn, nt = sr.process, at = sr.Deno, ot = nt && nt.versions || at && at.version, it = ot && ot.v8, y, re;
it && (y = it.split("."), re = y[0] > 0 && y[0] < 4 ? 1 : +(y[0] + y[1]));
!re && de && (y = de.match(/Edge\/(\d+)/), (!y || y[1] >= 74) && (y = de.match(/Chrome\/(\d+)/), y && (re = +y[1])));
var hn = re, st = hn, gn = $, mn = T, yn = mn.String, cr = !!Object.getOwnPropertySymbols && !gn(function() {
  var t = Symbol("symbol detection");
  return !yn(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && st && st < 41;
}), _n = cr, ur = _n && !Symbol.sham && typeof Symbol.iterator == "symbol", bn = ir, Sn = _, $n = K, wn = ur, Tn = Object, lr = wn ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  var e = bn("Symbol");
  return Sn(e) && $n(e.prototype, Tn(t));
}, xn = String, En = function(t) {
  try {
    return xn(t);
  } catch {
    return "Object";
  }
}, kn = _, In = En, On = TypeError, Ke = function(t) {
  if (kn(t)) return t;
  throw On(In(t) + " is not a function");
}, Dn = Ke, An = nr, Pn = function(t, e) {
  var r = t[e];
  return An(r) ? void 0 : Dn(r);
}, pe = Ve, ve = _, he = j, Rn = TypeError, Cn = function(t, e) {
  var r, n;
  if (e === "string" && ve(r = t.toString) && !he(n = pe(r, t)) || ve(r = t.valueOf) && !he(n = pe(r, t)) || e !== "string" && ve(r = t.toString) && !he(n = pe(r, t))) return n;
  throw Rn("Can't convert object to primitive value");
}, fr = { exports: {} }, ct = T, Nn = Object.defineProperty, jn = function(t, e) {
  try {
    Nn(ct, t, { value: e, configurable: !0, writable: !0 });
  } catch {
    ct[t] = e;
  }
  return e;
}, Mn = T, Un = jn, ut = "__core-js_shared__", Fn = Mn[ut] || Un(ut, {}), dr = Fn, lt = dr;
(fr.exports = function(t, e) {
  return lt[t] || (lt[t] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Ln = fr.exports, Bn = oe, Vn = Object, pr = function(t) {
  return Vn(Bn(t));
}, Gn = m, Kn = pr, qn = Gn({}.hasOwnProperty), ie = Object.hasOwn || function(e, r) {
  return qn(Kn(e), r);
}, Hn = m, Wn = 0, zn = Math.random(), Yn = Hn(1 .toString), Jn = function(t) {
  return "Symbol(" + (t === void 0 ? "" : t) + ")_" + Yn(++Wn + zn, 36);
}, Xn = T, Zn = Ln, ft = ie, Qn = Jn, ea = cr, ta = ur, A = Xn.Symbol, ge = Zn("wks"), ra = ta ? A.for || A : A && A.withoutSetter || Qn, M = function(t) {
  return ft(ge, t) || (ge[t] = ea && ft(A, t) ? A[t] : ra("Symbol." + t)), ge[t];
}, na = Ve, dt = j, pt = lr, aa = Pn, oa = Cn, ia = M, sa = TypeError, ca = ia("toPrimitive"), ua = function(t, e) {
  if (!dt(t) || pt(t)) return t;
  var r = aa(t, ca), n;
  if (r) {
    if (e === void 0 && (e = "default"), n = na(r, t, e), !dt(n) || pt(n)) return n;
    throw sa("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), oa(t, e);
}, la = ua, fa = lr, vr = function(t) {
  var e = la(t, "string");
  return fa(e) ? e : e + "";
}, da = T, vt = j, je = da.document, pa = vt(je) && vt(je.createElement), va = function(t) {
  return pa ? je.createElement(t) : {};
}, ha = q, ga = $, ma = va, hr = !ha && !ga(function() {
  return Object.defineProperty(ma("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), ya = q, _a = Ve, ba = Zt, Sa = tr, $a = ar, wa = vr, Ta = ie, xa = hr, ht = Object.getOwnPropertyDescriptor;
Xt.f = ya ? ht : function(e, r) {
  if (e = $a(e), r = wa(r), xa) try {
    return ht(e, r);
  } catch {
  }
  if (Ta(e, r)) return Sa(!_a(ba.f, e, r), e[r]);
};
var Ea = $, ka = _, Ia = /#|\.prototype\./, H = function(t, e) {
  var r = Da[Oa(t)];
  return r === Pa ? !0 : r === Aa ? !1 : ka(e) ? Ea(e) : !!e;
}, Oa = H.normalize = function(t) {
  return String(t).replace(Ia, ".").toLowerCase();
}, Da = H.data = {}, Aa = H.NATIVE = "N", Pa = H.POLYFILL = "P", Ra = H, gt = Be, Ca = Ke, Na = G, ja = gt(gt.bind), gr = function(t, e) {
  return Ca(t), e === void 0 ? t : Na ? ja(t, e) : function() {
    return t.apply(e, arguments);
  };
}, mr = {}, Ma = q, Ua = $, Fa = Ma && Ua(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), La = j, Ba = String, Va = TypeError, Ga = function(t) {
  if (La(t)) return t;
  throw Va(Ba(t) + " is not an object");
}, Ka = q, qa = hr, Ha = Fa, X = Ga, mt = vr, Wa = TypeError, me = Object.defineProperty, za = Object.getOwnPropertyDescriptor, ye = "enumerable", _e = "configurable", be = "writable";
mr.f = Ka ? Ha ? function(e, r, n) {
  if (X(e), r = mt(r), X(n), typeof e == "function" && r === "prototype" && "value" in n && be in n && !n[be]) {
    var a = za(e, r);
    a && a[be] && (e[r] = n.value, n = {
      configurable: _e in n ? n[_e] : a[_e],
      enumerable: ye in n ? n[ye] : a[ye],
      writable: !1
    });
  }
  return me(e, r, n);
} : me : function(e, r, n) {
  if (X(e), r = mt(r), X(n), qa) try {
    return me(e, r, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw Wa("Accessors not supported");
  return "value" in n && (e[r] = n.value), e;
};
var Ya = q, Ja = mr, Xa = tr, Za = Ya ? function(t, e, r) {
  return Ja.f(t, e, Xa(1, r));
} : function(t, e, r) {
  return t[e] = r, t;
}, Z = T, Qa = Wr, eo = Be, to = _, ro = Xt.f, no = Ra, O = Ge, ao = gr, D = Za, yt = ie, oo = function(t) {
  var e = function(r, n, a) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new t();
        case 1:
          return new t(r);
        case 2:
          return new t(r, n);
      }
      return new t(r, n, a);
    }
    return Qa(t, this, arguments);
  };
  return e.prototype = t.prototype, e;
}, W = function(t, e) {
  var r = t.target, n = t.global, a = t.stat, o = t.proto, i = n ? Z : a ? Z[r] : (Z[r] || {}).prototype, s = n ? O : O[r] || D(O, r, {})[r], u = s.prototype, f, v, d, l, h, k, I, w, se;
  for (l in e)
    f = no(n ? l : r + (a ? "." : "#") + l, t.forced), v = !f && i && yt(i, l), k = s[l], v && (t.dontCallGetSet ? (se = ro(i, l), I = se && se.value) : I = i[l]), h = v && I ? I : e[l], !(v && typeof k == typeof h) && (t.bind && v ? w = ao(h, Z) : t.wrap && v ? w = oo(h) : o && to(h) ? w = eo(h) : w = h, (t.sham || h && h.sham || k && k.sham) && D(w, "sham", !0), D(s, l, w), o && (d = r + "Prototype", yt(O, d) || D(O, d, {}), D(O[d], l, h), t.real && u && (f || !u[l]) && D(u, l, h)));
}, io = Math.ceil, so = Math.floor, co = Math.trunc || function(e) {
  var r = +e;
  return (r > 0 ? so : io)(r);
}, uo = co, yr = function(t) {
  var e = +t;
  return e !== e || e === 0 ? 0 : uo(e);
}, lo = yr, fo = Math.max, po = Math.min, vo = function(t, e) {
  var r = lo(t);
  return r < 0 ? fo(r + e, 0) : po(r, e);
}, ho = yr, go = Math.min, _r = function(t) {
  return t > 0 ? go(ho(t), 9007199254740991) : 0;
}, mo = _r, br = function(t) {
  return mo(t.length);
}, yo = ar, _o = vo, bo = br, So = function(t) {
  return function(e, r, n) {
    var a = yo(e), o = bo(a), i = _o(n, o), s;
    if (r !== r) {
      for (; o > i; )
        if (s = a[i++], s !== s) return !0;
    } else for (; o > i; i++)
      if (a[i] === r) return t;
    return !t;
  };
}, $o = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: So(!0)
}, wo = W, To = $o.includes, xo = $, Eo = xo(function() {
  return !Array(1).includes();
});
wo({ target: "Array", proto: !0, forced: Eo }, {
  includes: function(e) {
    return To(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var ko = Ge, z = function(t) {
  return ko[t + "Prototype"];
}, Io = z, Oo = Io("Array").includes, Do = j, Ao = ae, Po = M, Ro = Po("match"), Co = function(t) {
  var e;
  return Do(t) && ((e = t[Ro]) !== void 0 ? !!e : Ao(t) === "RegExp");
}, No = Co, jo = TypeError, Sr = function(t) {
  if (No(t))
    throw jo("The method doesn't accept regular expressions");
  return t;
}, Mo = M, Uo = Mo("toStringTag"), $r = {};
$r[Uo] = "z";
var Fo = String($r) === "[object z]", Lo = Fo, Bo = _, Q = ae, Vo = M, Go = Vo("toStringTag"), Ko = Object, qo = Q(/* @__PURE__ */ (function() {
  return arguments;
})()) === "Arguments", Ho = function(t, e) {
  try {
    return t[e];
  } catch {
  }
}, wr = Lo ? Q : function(t) {
  var e, r, n;
  return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (r = Ho(e = Ko(t), Go)) == "string" ? r : qo ? Q(e) : (n = Q(e)) === "Object" && Bo(e.callee) ? "Arguments" : n;
}, Wo = wr, zo = String, Tr = function(t) {
  if (Wo(t) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return zo(t);
}, Yo = M, Jo = Yo("match"), xr = function(t) {
  var e = /./;
  try {
    "/./"[t](e);
  } catch {
    try {
      return e[Jo] = !1, "/./"[t](e);
    } catch {
    }
  }
  return !1;
}, Xo = W, Zo = m, Qo = Sr, ei = oe, _t = Tr, ti = xr, ri = Zo("".indexOf);
Xo({ target: "String", proto: !0, forced: !ti("includes") }, {
  includes: function(e) {
    return !!~ri(
      _t(ei(this)),
      _t(Qo(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var ni = z, ai = ni("String").includes, bt = K, oi = Oo, ii = ai, Se = Array.prototype, $e = String.prototype, si = function(t) {
  var e = t.includes;
  return t === Se || bt(Se, t) && e === Se.includes ? oi : typeof t == "string" || t === $e || bt($e, t) && e === $e.includes ? ii : e;
}, ci = si, ui = ci, li = ui, U = /* @__PURE__ */ ne(li), fi = m, di = fi([].slice), Er = m, pi = Ke, vi = j, hi = ie, St = di, gi = G, kr = Function, mi = Er([].concat), yi = Er([].join), we = {}, _i = function(t, e, r) {
  if (!hi(we, e)) {
    for (var n = [], a = 0; a < e; a++) n[a] = "a[" + a + "]";
    we[e] = kr("C,a", "return new C(" + yi(n, ",") + ")");
  }
  return we[e](t, r);
}, bi = gi ? kr.bind : function(e) {
  var r = pi(this), n = r.prototype, a = St(arguments, 1), o = function() {
    var s = mi(a, St(arguments));
    return this instanceof o ? _i(r, s.length, s) : r.apply(e, s);
  };
  return vi(n) && (o.prototype = n), o;
}, Si = W, $t = bi;
Si({ target: "Function", proto: !0, forced: Function.bind !== $t }, {
  bind: $t
});
var $i = z, wi = $i("Function").bind, Ti = K, xi = wi, Te = Function.prototype, Ei = function(t) {
  var e = t.bind;
  return t === Te || Ti(Te, t) && e === Te.bind ? xi : e;
}, ki = Ei, Ii = ki, Oi = Ii, wt = /* @__PURE__ */ ne(Oi), Di = m, Ai = _, Me = dr, Pi = Di(Function.toString);
Ai(Me.inspectSource) || (Me.inspectSource = function(t) {
  return Pi(t);
});
var Ri = Me.inspectSource, Ci = m, Ni = $, Ir = _, ji = wr, Mi = ir, Ui = Ri, Or = function() {
}, Fi = [], Dr = Mi("Reflect", "construct"), qe = /^\s*(?:class|function)\b/, Li = Ci(qe.exec), Bi = !qe.exec(Or), F = function(e) {
  if (!Ir(e)) return !1;
  try {
    return Dr(Or, Fi, e), !0;
  } catch {
    return !1;
  }
}, Ar = function(e) {
  if (!Ir(e)) return !1;
  switch (ji(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return Bi || !!Li(qe, Ui(e));
  } catch {
    return !0;
  }
};
Ar.sham = !0;
!Dr || Ni(function() {
  var t;
  return F(F.call) || !F(Object) || !F(function() {
    t = !0;
  }) || t;
});
var Vi = M;
Vi("species");
var Gi = gr, Ki = m, qi = rr, Hi = pr, Wi = br, Tt = Ki([].push), zi = function(t) {
  return function(e, r, n, a) {
    for (var o = Hi(e), i = qi(o), s = Gi(r, n), u = Wi(i), f = 0, v = void 0, d, l; u > f; f++)
      if (d = i[f], l = s(d, f, o), l) switch (t) {
        case 3:
          return !0;
        // some
        case 5:
          return d;
        // find
        case 6:
          return f;
        // findIndex
        case 2:
          Tt(v, d);
      }
      else switch (t) {
        case 4:
          return !1;
        // every
        case 7:
          Tt(v, d);
      }
    return v;
  };
}, Yi = {
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: zi(5)
}, Ji = W, Xi = Yi.find, xt = "find", Pr = !0;
xt in [] && Array(1)[xt](function() {
  Pr = !1;
});
Ji({ target: "Array", proto: !0, forced: Pr }, {
  find: function(e) {
    return Xi(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Zi = z, Qi = Zi("Array").find, es = K, ts = Qi, xe = Array.prototype, rs = function(t) {
  var e = t.find;
  return t === xe || es(xe, t) && e === xe.find ? ts : e;
}, ns = rs, as = ns, os = as, is = /* @__PURE__ */ ne(os), ss = W, Rr = Be, cs = _r, Et = Tr, us = Sr, ls = oe, fs = xr, kt = Rr("".startsWith), ds = Rr("".slice), ps = Math.min, vs = fs("startsWith");
ss({ target: "String", proto: !0, forced: !vs }, {
  startsWith: function(e) {
    var r = Et(ls(this));
    us(e);
    var n = cs(ps(arguments.length > 1 ? arguments[1] : void 0, r.length)), a = Et(e);
    return kt ? kt(r, a, n) : ds(r, n, n + a.length) === a;
  }
});
var hs = z, gs = hs("String").startsWith, ms = K, ys = gs, Ee = String.prototype, _s = function(t) {
  var e = t.startsWith;
  return typeof t == "string" || t === Ee || ms(Ee, t) && e === Ee.startsWith ? ys : e;
}, bs = _s, Ss = bs, $s = Ss, ws = /* @__PURE__ */ ne($s);
function It(t) {
  t = t.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const r = new RegExp(`[\\?&]${t}=([^&#]*)`).exec(location.search);
  return r === null ? null : Ts(r[1].replace(/\+/g, " "));
}
function Ts(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    return console.warn(`Failed to decode param value '${t}'`), t;
  }
}
const Cr = {
  backendDomain: "dixa:backend-domain"
};
function xs() {
  const t = It("staging") || It("backend-domain");
  if (t) {
    const e = /^\d+$/.test(t) ? `euw1.stag${t === "1" ? "" : t}.dixa.io` : t;
    return ks(e), e;
  }
  return null;
}
function Es() {
  var t;
  const e = is(t = document.cookie.split("; ")).call(t, (r) => ws(r).call(r, `${Cr.backendDomain}=`));
  return e ? decodeURIComponent(e.split("=")[1]) : null;
}
function ks(t) {
  document.cookie = `${Cr.backendDomain}=${encodeURIComponent(t)}; path=/; max-age=31536000; SameSite=Lax`;
}
var Ot, ke, Dt, Ie, At, Pt, Rt;
const x = {
  restApiUrl: "_dixa-rest-api-url",
  partnerIntegrationsApiUrl: "_dixa-partner-integrations-api-url",
  filesApiUrl: "_dixa-files-api-url",
  loginUrl: "_dixa-login-url",
  signUpUrl: "_dixa-sign-up-url",
  subdomain: "_dixa-subdomain",
  webSocketUrl: "_dixa-websocket-url"
}, Oe = window.location.origin.replace(/^https?:\/\//, ""), g = xs() ?? Es(), c = {
  // The development domains.
  develop: ["localhost:8080", "dixadev.com", "dixa.io"],
  // The testing domains.
  test: {
    // The security testing domains.
    security: ["dixa-security.com", "dixa-security.net"],
    // The automation testing domains.
    automation: ["localhost:9999", "test-agent-interface.dixa.io", "test.dixatest.com", "okta-test-org.dixatest.com"]
  },
  // The custom subdomains.
  custom: ["thehaddaway.dixa.com", "demo.dixa.com", "developer.dixa.com", "okta-test.dixa.com", "development.dixa.com", "engineering.dixa.com"],
  default: {
    email: "dixa.com",
    emailIntegration: "email.dixa.io",
    integrations: "docs.dixa.io",
    service: "dixa.io",
    status: "status.dixa.io",
    subdomain: localStorage.getItem(x.subdomain) ?? "demo",
    userContent: "dixausercontent.com",
    web: "dixa.com",
    accounts: "accounts.dixa.com",
    knowledge: "knowledge-backend-cdn"
  }
}, Is = {
  assets: `https://assets.${c.default.service}`,
  toolkit: `https://toolkit.${c.default.service}`,
  widget: `https://widget.${c.default.service}`,
  rest: localStorage.getItem(x.restApiUrl) ?? `https://api.${g ?? c.default.service}`,
  partnerIntegrations: localStorage.getItem(x.partnerIntegrationsApiUrl) ?? `https://partner-integrations.${g ?? c.default.service}`,
  files: localStorage.getItem(x.filesApiUrl) ?? `https://files.${g ?? c.default.service}`,
  webSocket: localStorage.getItem(x.webSocketUrl) ?? `wss://agent-sockets.${g ?? c.default.service}/v2/agent/`,
  userContent: g ? `https://raw.${g.replace(c.default.service, c.default.userContent)}` : `https://raw.${c.default.userContent}`,
  signUp: localStorage.getItem(x.signUpUrl) ?? `https://${c.default.accounts}/signup`,
  logIn: localStorage.getItem(x.loginUrl) ?? `https://${c.default.accounts}/signin`,
  smartConversationReply: Ue(g) === "prod" ? `https://knowledge-backend-cdn.${c.default.service}` : `https://knowledge-backend-cdn.stag.${c.default.service}`,
  dixaKnowledgeBackend: Ue(g) === "prod" ? `https://knowledge-backend.${c.default.service}` : `https://knowledge-backend.stag.${c.default.service}`
}, Os = {
  amplitude: {
    environment: U(Ot = [...c.test.automation, ...c.develop, ...c.test.security, ...c.custom]).call(Ot, Oe) || ((ke = g) == null ? void 0 : wt(Dt = Function.call).call(Dt, U(ke), ke))?.(".stag") || ((Ie = g) == null ? void 0 : wt(At = Function.call).call(At, U(Ie), Ie))?.(".dev") ? "stag" : "prod"
  },
  launchDarkly: U(Pt = c.develop).call(Pt, Oe) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
  stripe: U(Rt = c.develop).call(Rt, Oe) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
  elevio: "599d54aacd7bd",
  birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
  jabra: {
    partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
    appId: "Dixa",
    appName: "Dixa"
  }
};
function Ue(t) {
  const e = t?.match(/(dev|stag\d?)/);
  return !e || e.length < 2 ? "prod" : e[1];
}
const B = {
  environment: Ue(g),
  domain: c.default,
  sdk: Os,
  url: Is,
  backendDomain: g
};
class Ds {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const Ct = new Ds();
function As(t, e) {
  return Nt(t), Nt(e), t.localeCompare(e, void 0, {
    numeric: !0
  });
}
function Nt(t) {
  if (t.split(".").length !== 3)
    throw Error(`The version '${t}' must be in the format 'x.x.x'.`);
}
const Ps = Object.prototype.toString;
function Rs(t, e) {
  return Ps.call(t) === `[object ${e}]`;
}
function Cs(t) {
  return Rs(t, "Object");
}
function Ns(t) {
  return !!(t && t.then && typeof t.then == "function");
}
const L = "8.36.0", S = globalThis;
function He(t, e, r) {
  const n = r || S, a = n.__SENTRY__ = n.__SENTRY__ || {}, o = a[L] = a[L] || {};
  return o[t] || (o[t] = e());
}
const Nr = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, js = "Sentry Logger ", jt = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Mt = {};
function jr(t) {
  if (!("console" in S))
    return t();
  const e = S.console, r = {}, n = Object.keys(Mt);
  n.forEach((a) => {
    const o = Mt[a];
    r[a] = e[a], e[a] = o;
  });
  try {
    return t();
  } finally {
    n.forEach((a) => {
      e[a] = r[a];
    });
  }
}
function Ms() {
  let t = !1;
  const e = {
    enable: () => {
      t = !0;
    },
    disable: () => {
      t = !1;
    },
    isEnabled: () => t
  };
  return Nr ? jt.forEach((r) => {
    e[r] = (...n) => {
      t && jr(() => {
        S.console[r](`${js}[${r}]:`, ...n);
      });
    };
  }) : jt.forEach((r) => {
    e[r] = () => {
    };
  }), e;
}
const ee = He("logger", Ms);
function Us(t, e, r) {
  try {
    Object.defineProperty(t, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Nr && ee.log(`Failed to add non-enumerable property "${e}" to object`, t);
  }
}
const Mr = 1e3;
function We() {
  return Date.now() / Mr;
}
function Fs() {
  const { performance: t } = S;
  if (!t || !t.now)
    return We;
  const e = Date.now() - t.now(), r = t.timeOrigin == null ? e : t.timeOrigin;
  return () => (r + t.now()) / Mr;
}
const Ls = Fs();
(() => {
  const { performance: t } = S;
  if (!t || !t.now)
    return;
  const e = 3600 * 1e3, r = t.now(), n = Date.now(), a = t.timeOrigin ? Math.abs(t.timeOrigin + r - n) : e, o = a < e, i = t.timing && t.timing.navigationStart, u = typeof i == "number" ? Math.abs(i + r - n) : e, f = u < e;
  return o || f ? a <= u ? t.timeOrigin : i : n;
})();
function P() {
  const t = S, e = t.crypto || t.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (r = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (r() & 15) >> n / 4).toString(16)
    )
  );
}
function Ut() {
  return {
    traceId: P(),
    spanId: P().substring(16)
  };
}
function ze() {
  return Ye(S), S;
}
function Ye(t) {
  const e = t.__SENTRY__ = t.__SENTRY__ || {};
  return e.version = e.version || L, e[L] = e[L] || {};
}
function Bs(t, e = {}) {
  if (e.user && (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address), !t.did && !e.did && (t.did = e.user.id || e.user.email || e.user.username)), t.timestamp = e.timestamp || Ls(), e.abnormal_mechanism && (t.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration), e.sid && (t.sid = e.sid.length === 32 ? e.sid : P()), e.init !== void 0 && (t.init = e.init), !t.did && e.did && (t.did = `${e.did}`), typeof e.started == "number" && (t.started = e.started), t.ignoreDuration)
    t.duration = void 0;
  else if (typeof e.duration == "number")
    t.duration = e.duration;
  else {
    const r = t.timestamp - t.started;
    t.duration = r >= 0 ? r : 0;
  }
  e.release && (t.release = e.release), e.environment && (t.environment = e.environment), !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress), !t.userAgent && e.userAgent && (t.userAgent = e.userAgent), typeof e.errors == "number" && (t.errors = e.errors), e.status && (t.status = e.status);
}
const Fe = "_sentrySpan";
function Ft(t, e) {
  e ? Us(t, Fe, e) : delete t[Fe];
}
function Lt(t) {
  return t[Fe];
}
const Vs = 100;
class Je {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Ut();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new Je();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e._lastEventId = this._lastEventId, Ft(e, Lt(this)), e;
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Bs(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, r) {
    return this._tags = { ...this._tags, [e]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, r) {
    return this._extra = { ...this._extra, [e]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, r) {
    return r === null ? delete this._contexts[e] : this._contexts[e] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const r = typeof e == "function" ? e(this) : e, [n, a] = r instanceof C ? [r.getScopeData(), r.getRequestSession()] : Cs(r) ? [e, e.requestSession] : [], { tags: o, extra: i, user: s, contexts: u, level: f, fingerprint: v = [], propagationContext: d } = n || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...u }, s && Object.keys(s).length && (this._user = s), f && (this._level = f), v.length && (this._fingerprint = v), d && (this._propagationContext = d), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Ft(this, void 0), this._attachments = [], this._propagationContext = Ut(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, r) {
    const n = typeof r == "number" ? r : Vs;
    if (n <= 0)
      return this;
    const a = {
      timestamp: We(),
      ...e
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > n ? o.slice(-n) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Lt(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, r) {
    const n = r && r.event_id ? r.event_id : P();
    if (!this._client)
      return ee.warn("No client configured on scope - will not capture exception!"), n;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: a,
        ...r,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, r, n) {
    const a = n && n.event_id ? n.event_id : P();
    if (!this._client)
      return ee.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(e);
    return this._client.captureMessage(
      e,
      r,
      {
        originalException: e,
        syntheticException: o,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, r) {
    const n = r && r.event_id ? r.event_id : P();
    return this._client ? (this._client.captureEvent(e, { ...r, event_id: n }, this), n) : (ee.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
const C = Je;
function Gs() {
  return He("defaultCurrentScope", () => new C());
}
function Ks() {
  return He("defaultIsolationScope", () => new C());
}
class qs {
  constructor(e, r) {
    let n;
    e ? n = e : n = new C();
    let a;
    r ? a = r : a = new C(), this._stack = [{ scope: n }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const r = this._pushScope();
    let n;
    try {
      n = e(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return Ns(n) ? n.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function N() {
  const t = ze(), e = Ye(t);
  return e.stack = e.stack || new qs(Gs(), Ks());
}
function Hs(t) {
  return N().withScope(t);
}
function Ws(t, e) {
  const r = N();
  return r.withScope(() => (r.getStackTop().scope = t, e(t)));
}
function Bt(t) {
  return N().withScope(() => t(N().getIsolationScope()));
}
function zs() {
  return {
    withIsolationScope: Bt,
    withScope: Hs,
    withSetScope: Ws,
    withSetIsolationScope: (t, e) => Bt(e),
    getCurrentScope: () => N().getScope(),
    getIsolationScope: () => N().getIsolationScope()
  };
}
function Ur(t) {
  const e = Ye(t);
  return e.acs ? e.acs : zs();
}
function Xe() {
  const t = ze();
  return Ur(t).getCurrentScope();
}
function Fr() {
  const t = ze();
  return Ur(t).getIsolationScope();
}
function Ys() {
  return Xe().getClient();
}
function Js(t) {
  if (t)
    return Xs(t) ? { captureContext: t } : Qs(t) ? {
      captureContext: t
    } : t;
}
function Xs(t) {
  return t instanceof C || typeof t == "function";
}
const Zs = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Qs(t) {
  return Object.keys(t).some((e) => Zs.includes(e));
}
function Vt(t, e) {
  return Xe().captureException(t, Js(e));
}
function ec(t, e) {
  const r = typeof e == "string" ? e : void 0, n = typeof e != "string" ? { captureContext: e } : void 0;
  return Xe().captureMessage(t, r, n);
}
function tc(t, e) {
  Fr().setContext(t, e);
}
const rc = 100;
function E(t, e) {
  const r = Ys(), n = Fr();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = rc } = r.getOptions();
  if (o <= 0) return;
  const s = { timestamp: We(), ...t }, u = a ? jr(() => a(s, e)) : s;
  u !== null && (r.emit && r.emit("beforeAddBreadcrumb", u, e), n.addBreadcrumb(u, o));
}
var V;
(function(t) {
  t.Unknown = "unknown", t.Core = "core", t.Routing = "routing-and-presence", t.Insights = "insights", t.Ecosystem = "ecosystem", t.Partners = "partners", t.Channels = "channels", t.Messaging = "messaging", t.Platform = "platform", t.AI = "ai", t.Conversations = "conversations", t.Automation = "automation";
})(V || (V = {}));
function R(t) {
  const e = t.split(".")[1];
  if (!e)
    throw Error("Invalid token");
  const r = e.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (n) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${n}`);
  }
}
const nc = B.backendDomain ? {
  "backend-domain": B.backendDomain
} : void 0;
function te() {
  const t = new URLSearchParams({
    noToken: "true",
    ...nc
  }).toString();
  document.location.href = `${B.url.logIn}?${t}`;
}
const De = "authData", Ae = 30, ac = 600, Pe = 5;
class oc {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const e = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Pe || this.clientServerTimeDiff <= -Pe ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(e) {
    this.authData = e;
    const n = Math.ceil(Date.now() / 1e3) + ac, a = R(e.access_token).exp;
    if (this.clientServerTimeDiff = a - n, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Pe) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(De, JSON.stringify(e));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const e = localStorage.getItem(De), r = e ? JSON.parse(e) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(De);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(e) {
    return e ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((n) => typeof e[n] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - Ae;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(e) {
    if (!e)
      return !0;
    const r = R(e), n = r.exp - Ae;
    return !r || this.estimatedServerTime() >= n;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Ae - this.estimatedServerTime()) * 1e3;
  }
}
const p = new oc();
async function ic(t) {
  const e = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!t.response || r.some((n) => e.includes(n)))) {
    try {
      const n = t.response.config.headers.Authorization ?? "", a = n ? n.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", i = o ? R(o).exp : "None", s = await Ze.getAuthData({ localStorageOnly: !0 }), u = Math.floor(Date.now() / 1e3), f = s?.access_token, v = s?.refresh_token, d = f ? R(f).exp : "None", l = v ? R(v).exp : "None", h = typeof i == "number" ? u - i : "Unknown", k = typeof d == "number" ? u - d : "Unknown", I = typeof l == "number" ? u - l : "Unknown", w = t.response.headers["x-dixa-rid"];
      tc("Expires", {
        currentTimestamp: u,
        accessTokenFromHeader: i,
        accessTokenFromHeaderDiff: h,
        accessTokenFromLocalStorage: d,
        accessTokenFromLocalStorageDiff: k,
        refreshTokenFromLocalStorage: l,
        refreshTokenFromLocalStorageDiff: I,
        xDixaRid: w,
        navigatorOnline: navigator.onLine
      });
    } catch (n) {
      console.error("Error adding Sentry error context", n);
    }
    ec("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: V.Platform,
        domain: e
      }
    });
  }
}
const Re = /* @__PURE__ */ new Map(), sc = 3;
function cc(t) {
  t.interceptors.response.use((e) => (Re.delete(e.config.url), e), (e) => {
    if (e.response) {
      const { status: r } = e.response;
      switch (r) {
        case Le.Unauthorized:
          if (!Ze.isRefreshTokenExpired() && e.config) {
            E({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const n = Re.get(e.config.url) ?? 0;
            if (console.log(`Retrying request (${n + 1}): ${e.config.url}`), n <= sc)
              return Re.set(e.config.url, n + 1), t(e.config);
          }
          ic(e), console.error("401 unauthorized interceptor"), te();
          break;
      }
    }
    return Promise.reject(e);
  });
}
const Lr = Kt.create();
cc(Lr);
const b = console.log;
async function Gt(t) {
  return new Promise((e) => setTimeout(e, t * 1e3));
}
class uc extends Error {
  constructor(e, r) {
    super(e, r);
  }
}
function lc(t = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, t)), 30);
}
const fc = 5;
class dc {
  authDataPromise = null;
  retryCount = 0;
  async init(e) {
    const r = await this.refresh(e);
    if (r)
      p.setAuthData(r);
    else {
      const n = p.isRefreshTokenExpired(e) ? "expired" : "unknown";
      throw new uc("Failed to init refresh token", {
        cause: n
      });
    }
  }
  getDebugInfo() {
    const e = p.getAccessToken();
    if (!e)
      return {};
    const r = R(e), { exp: n } = r;
    return {
      expire: n ? new Date(n * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: e = !1 } = {}) {
    if (e)
      return p.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = p.getAuthData();
    return r ? p.isAccessTokenExpired() ? (E({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((n) => (n && p.setAuthData(n), this.authDataPromise = null, n)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return p.removeAuthData();
  }
  validateAuthDataComplete(e) {
    return p.validateAuthDataComplete(e);
  }
  isAccessTokenExpired() {
    return p.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const e = p.getAuthData();
    return e ? p.isRefreshTokenExpired(e.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!Ct.isElectron())
      return !0;
    const e = await Ct.getVersion();
    return As(e, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(e, r = fc) {
    try {
      return await Lr.post(`${B.url.rest}/v2/login/refresh`, {
        refreshToken: e
      }).then((n) => (this.retryCount = 0, n.data.data));
    } catch (n) {
      return await this.handleRefreshError(n, e, r);
    }
  }
  async waitUntilOnline() {
    const e = navigator.onLine === !1;
    for (e && (b("AUTH", "Network connection offline - waiting..."), E({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Gt(5);
    e && (b("AUTH", "Network connection restored"), E({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(e, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const n = lc(this.retryCount);
    return b("AUTH", `Retrying in ${n} seconds`), await Gt(n), await this.refresh(e, r);
  }
  async handleRefreshError(e, r, n) {
    if (p.isRefreshTokenExpired(r))
      return b("AUTH", "Refresh token expired"), E({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), p.removeAuthData(), te(), null;
    if (Br(e)) {
      if (e.message === "timeout exceeded")
        return b("AUTH", "Timeout exceeded"), E({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, n);
      if (e.message === "Network Error")
        return b("AUTH", "Network error"), E({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, n);
      if (e.response?.status === 401)
        return b("AUTH", "Refresh token invalid (401)"), p.removeAuthData(), te(), null;
      Vt(e, {
        level: "error",
        tags: {
          team: V.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return n <= 0 ? (b("AUTH", "Retries exhausted, logging out"), Vt(e, {
      level: "error",
      tags: {
        team: V.Platform,
        errorSource: "authManager.refresh"
      }
    }), p.removeAuthData(), te(), null) : (b("AUTH", `Retrying ${n} more times`), await this.retryRefresh(r, n - 1));
  }
  accessTokenExpiresInMs() {
    return p.accessTokenExpiresInMs();
  }
}
const Ze = new dc();
var Le;
(function(t) {
  t[t.BadRequest = 400] = "BadRequest", t[t.Unauthorized = 401] = "Unauthorized", t[t.Forbidden = 403] = "Forbidden", t[t.NotFound = 404] = "NotFound", t[t.Conflict = 409] = "Conflict", t[t.InternalServerError = 500] = "InternalServerError", t[t.BadGateway = 502] = "BadGateway", t[t.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Le || (Le = {}));
const pc = Kt.create();
class vc {
  /** The current logged in user. */
  user = null;
  /** The list of authorization scopes assigned to the current user. */
  scopes = null;
  /** This list of user roles assigned to the current user */
  _roles = null;
  /** Checks if the service has been initialized. */
  get isInitialized() {
    return this.user !== null;
  }
  /** Initializes the access control service. */
  async init({
    user: e
  }) {
    this.user = e;
    const r = await this.introspectAccessToken();
    r && (this.scopes = r.scope, this._roles = r.roles);
  }
  /** Exposed read-only list of user roles assigned to the current user */
  get roles() {
    return this._roles;
  }
  /**
   * Checks if the current user has access to one or more scopes.
   *
   * @param scopes - The scope(s) to check.
   * @param options - The options to use when checking multiple scopes.
   * @param options.strategy - The strategy to use when checking multiple
   *   scopes. Can be "all" or "any".
   * @returns Whether or not the user has access to the scope(s).
   */
  hasAccess(e, r) {
    if (!this.isInitialized || this.scopes === null)
      return !1;
    if (Array.isArray(e)) {
      const { strategy: n = "all" } = r ?? {};
      return n === "all" ? e.every(this.hasScope) : e.some(this.hasScope);
    }
    return this.scopes.includes(e);
  }
  /** Checks if the user has a certain scope. */
  hasScope = (e) => this.scopes.includes(e);
  /**
   * Fetches the introspection data of the current access_token and stores it in
   * memory. This should be called only once on init.
   */
  async introspectAccessToken() {
    const e = await Ze.getAuthData({ localStorageOnly: !0 });
    if (!e) return null;
    try {
      return (await pc.post(
        `${B.url.rest}/v1/introspect`,
        {
          token: e.access_token
        },
        {
          transformResponse: (n) => {
            const a = JSON.parse(n);
            return {
              ...a,
              /**
               * As per the spec, the backend returns the `scope` as a
               * space-separated string. We convert it to an array of strings to
               * make it easier for us.
               *
               * @see https://datatracker.ietf.org/doc/html/rfc7662#section-2.2
               */
              scope: a.scope ? a.scope.split(" ") : []
            };
          }
        }
      )).data;
    } catch {
      return null;
    }
  }
  reset() {
    this.user = null, this.scopes = null, this._roles = null;
  }
}
const hc = new vc(), yc = (t, e) => Vr(
  () => hc.hasAccess(t, e),
  // The arguments are statically defined when consuming the hook, therefore we don't need to
  // recompute the result on every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
);
export {
  hc as accessControl,
  yc as useHasAccess
};
//# sourceMappingURL=index.js.map
